import React from 'react';
import classnames from 'classnames';
import { connect } from 'redux-bundler-react';
import DatasetInfo from './dataset-info-modal';
import isEmpty from 'lodash/isEmpty';

// class TreeListFolder extends React.Component {
//   constructor(props){
//     super(props);
//     this.renderInfoButton = this.renderInfoButton.bind(this);
//     this.renderSimDamsButton = this.renderSimDamsButton.bind(this);
//     this.openMetadata = this.openMetadata.bind(this);
//     this.openLibrary = this.openLibrary.bind(this);
//   }
//   renderInfoButton(){
//     const { item } = this.props;
//     return null
//     // if(item.info && item.info.url) {
//     //   return (
//     //     <span
//     //         onClick={this.openMetadata}
//     //         title="More Information"
//     //         style={{paddingLeft: '4px', cursor: 'pointer'}}
//     //       >
//     //         <i className="mdi mdi-alert-circle-outline"></i>
//     //     </span>
//     //   )
//     // }else{
//     //   return null
//     // }    
//   }
//   renderSimDamsButton(){
//     const { item } = this.props;
//     if(item.info && item.info.SIMDAMS_INFO_ID) {
//       return (
//         <span
//             onClick={this.openLibrary}
//             title="Open Structure Info"
//             style={{paddingLeft: '4px', cursor: 'pointer'}}
//           >
//             <i className="fv fv-simdams icon-inline"></i>
//         </span>
//       )
//     }else{
//       return null
//     }   
    
//   }
//   openLibrary(){
//     const { doOpenLinkedProject, item } = this.props;
    
//     doOpenLinkedProject(item.info.SIMDAMS_INFO_ID, 'simdams')
//   }
//   openMetadata(){
//     const { doOpenModalWindow, item } = this.props;
//     doOpenModalWindow({
//       children: [DatasetInfo],
//       options: {item: item},
//       openedBy: 'ds-folder'
//     })
//   }

//   render(){
//     const { item, collapsed, toggleCollapsed } = this.props;
//     const iconClass = classnames({
//       "mdi": true,
//       "mdi-folder-open": !collapsed,
//       "mdi-folder": collapsed
//     })
//     const itemClass = classnames({
//       "tree-list-item-hover": false
//     })
//     const divStyle ={
//       display:'inline-block',
//       paddingLeft: '8px'
//     }
//     const count = item.children.length;
//     return (
//       <div className="layertree-layeritem">
//         <i title="Click to collapse or expand" 
//           onClick={toggleCollapsed} 
//           className={iconClass} 
//           style={{fontSize:'16px', cursor:'pointer'}}>
//         </i>
//         <span>
//           <div 
//             className={itemClass} 
//             style={divStyle}
//             onDoubleClick={toggleCollapsed}>
//             { item.displayName }
//           </div>
//           <span>
//             {' (' + count + ')'}
//           </span>
//           {
//           this.renderSimDamsButton()
//         }
//         </span>
//         {/* { 
//           this.renderInfoButton() 
//         } */}
       
//       </div>
//     )
//   }
// }

class TreeListFolder extends React.Component {
  constructor(props){
    super(props);
    this.renderInfoButton = this.renderInfoButton.bind(this);
    this.renderSimDamsButton = this.renderSimDamsButton.bind(this);
    this.openMetadata = this.openMetadata.bind(this);
    this.openLibrary = this.openLibrary.bind(this);
  }
  renderInfoButton(){
    const { item } = this.props;
    return null
    // if(item.info && item.info.url) {
    //   return (
    //     <span
    //         onClick={this.openMetadata}
    //         title="More Information"
    //         style={{paddingLeft: '4px', cursor: 'pointer'}}
    //       >
    //         <i className="mdi mdi-alert-circle-outline"></i>
    //     </span>
    //   )
    // }else{
    //   return null
    // }    
  }
  renderSimDamsButton() {
    const { item } = this.props;
    if(item.info && item.info.SIMDAMS_INFO_ID) {
      return (
        <span
            onClick={this.openLibrary}
            title="Open Structure Info"
            style={{paddingLeft: '4px', cursor: 'pointer'}}
          >
            <i className="fv fv-simdams icon-inline"></i>
        </span>
      )
    }else{
      return null
    }   
    
  }
  openLibrary(){
    const { doOpenLinkedProject, item } = this.props;
    
    doOpenLinkedProject(item.info.SIMDAMS_INFO_ID, 'simdams')
  }
  openMetadata(){
    const { doOpenModalWindow, item } = this.props;
    doOpenModalWindow({
      children: [DatasetInfo],
      options: {item: item},
      openedBy: 'ds-folder'
    })
  }
  render(){
    const { item, collapsed, toggleCollapsed } = this.props;
    const iconClass = classnames({
      "mdi": true,
      "mdi-folder-open": !collapsed,
      "mdi-folder": collapsed
    })
    const itemClass = classnames({
      "tree-list-item-hover": false
    })
    const divStyle ={
      display:'inline-block',
      paddingLeft: '8px'
    }
    const count = item.children.length;
    return (
      <div className="layertree-layeritem">
        <i title="Click to collapse or expand" 
          onClick={toggleCollapsed} 
          className={iconClass} 
          style={{fontSize:'16px', cursor:'pointer'}}>
        </i>
        <span>
          <div 
            className={itemClass} 
            style={divStyle}
            onDoubleClick={toggleCollapsed}>
            { item.displayName }
            <span>
              {' (' + count + ')'}
            </span>
          </div>
          {
          this.renderSimDamsButton()
        }
        </span>
      </div>
    )
  }
}


export default connect(
  'doOpenModalWindow',
  'doOpenLinkedProject',
  TreeListFolder
);